import { SITE } from '../data/site';
import { BILLING, fmtPrice, planByTier } from '../data/pricing';
import { VIDEO_TEMPLATES, resolveMedia } from '../data/videoTemplates';
import { useSession } from '../utils/session';
import { useCountdown } from '../utils/useCountdown';
import { Icon } from './Icon';
import './OfferCard.css';

const PLAN = planByTier(1);
// Scenes from page 2, so the circles never repeat a card that is on screen next to the offer.
const ART = VIDEO_TEMPLATES.slice(11, 14).map((t) => resolveMedia(t).poster);

// A leaf on purpose: it re-renders every second and must not drag the video grid along.
function Countdown() {
    const { mm, ss } = useCountdown();
    return (
        <span className="offerTimer" role="timer" aria-live="off" aria-label={`Offer ends in ${mm} minutes ${ss} seconds`}>
            <span className="offerTimerLabel">Offer ends in</span>
            <span className="offerTimerShort">Ends in</span>
            <b>{mm}</b><i>:</i><b>{ss}</b>
        </span>
    );
}

// The price tag inside the scene grid. `card` fills the 2x1 bento slot, `bar` is a full-width strip.
export function OfferCard({ variant = 'card', order = 0, className = '' }) {
    const { requireSub } = useSession();

    return (
        <aside className={`offer offer--${variant} ${className}`} style={{ '--i': order }} aria-label="Subscription offer">
            <div className="offerHead">
                <span className="eyebrow"><span className="dot dot--pulse" /><span className="offerEyebrowText">Limited offer</span></span>
                <Countdown />
            </div>

            <div className="offerMain">
                <div className="offerText">
                    <h2 className="offerTitle">Undress AI girl</h2>
                    <div className="offerPriceRow">
                        <span className="offerPrice">{fmtPrice(PLAN.price)}</span>
                        {PLAN.offerStrike && <s className="offerStrike">{fmtPrice(PLAN.offerStrike)}</s>}
                        <span className="offerPer">/ {BILLING.per}</span>
                    </div>
                </div>
                <div className="offerArt" aria-hidden="true">
                    {ART.map((src, i) => <img key={src} className={`offerArtImg offerArtImg--${i}`} src={src} alt="" loading="lazy" decoding="async" />)}
                </div>
            </div>

            <div className="offerFoot">
                <button type="button" className="btn btn--primary offerCta" onClick={() => requireSub()}>
                    Get access <Icon name="arrowRight" size={16} strokeWidth={2.4} />
                </button>
                <span className="offerFine">
                    Cancel anytime · Secure checkout via {SITE.checkoutProvider}
                </span>
            </div>
        </aside>
    );
}
